import { EditItem, IEditItem } from "./../common/editItem";
import { IModifyUser, ModifyUser } from "./../user/modifyUser";

export interface IEventUrgencyClassEditItem extends IEditItem {
    code: string;
    comment: string;
    sortOrder: number;
    color: string;
    defaultUrgencyClass: boolean;
    activeState: number;
    modifyUser: IModifyUser;
}

export class EventUrgencyClassEditItem extends EditItem implements IEventUrgencyClassEditItem {
    code: string;
    comment: string;
    sortOrder: number;
    color: string;
    defaultUrgencyClass: boolean;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IEventUrgencyClassEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.color = obj && obj.color || "";
        this.defaultUrgencyClass = obj && obj.defaultUrgencyClass || false;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}